<template>
  <HeadWithLogo/>
  <h4 class="pt-4">چند نکته مهم قبل از ثبت نام نهایی</h4>
  <br/>
  <p class="bold-p px-2">
    1- دوباره عرض میشود: سامانه ناظر یک دارای قدرت اجرایی و قضایی است و اگر فردی تایید گردد، باید نهایت دقت را در ثبت درست تخلف و شماره پلاک و تطبیق آن با مدل و رنگ ماشین مد نظر داشته باشد که خدای نکرده اشتباهی حاصل نشود.
  </p>
  <p class="bold-p px-2">
    2- روند اجرایی کار به این نحو است که پس از ثبت نام شما در صفحه بعد، مدارک شما بررسی میگردد و در صورت تایید، بعد از مدت حداکثر یک ماه پیامک ثبت نرم افزار به تلفن همراهتان ارسال می گردد.
  </p>
  <p class="bold-p px-2">
    جهت ثبت نام نهایی به صفحه بعد مراجعه بفرمایید.
  </p>
  <br/>
  <div class="text-center mt-3">
    <span class="sp-danger"> در صورت وجود سوال یا اشکال، در پیام رسان واتساپ، ایتا و بله به شماره 09960936122 پیام دهید. </span>
  </div>
  <div class="row mt-3">
    <div class="col-12 text-start">
      <RouterLink to="/complete-form" class="btn btn-success px-4">
        صفحه بعد
      </RouterLink>
    </div>
  </div>
</template>

<script>
import HeadWithLogo from "@/components/HeadWithLogo";

export default {
  components: {HeadWithLogo}
}
</script>

<style scoped>

</style>